// extracted by mini-css-extract-plugin
module.exports = {"dialog":"ComingSoonModal_dialog__3PLHE","title":"ComingSoonModal_title__1kYPn","description":"ComingSoonModal_description__22QCe"};